// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4482":"d99c4a04","5824":"78d5c18a","8951":"ca19e2b2"}[chunkId] + ".css";
};